import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useAppContext } from "./AppContext";
import AppflyteTransactionApi from "../Api/Services/AppflyteBackend/AppflyteTransactionApi";
import { toNumber } from "lodash";

const CreditContext = createContext();

export const CreditProvider = ({ children }) => {

    const { selectedOrganization } = useAppContext();
    const [credit, setCredit] = useState(null);
    const [creditLoading, setCreditLoading] = useState(true);

    useEffect(() => {
        fetchCreditBalance()
    }, [selectedOrganization])

    const fetchCreditBalance = async () => {
        try {
            setCreditLoading(true);

            if (window.__ENV__.SFS_INSTANCE_STATUS === "true") {
                setCredit(100);
                setCreditLoading(false);
                return
            }

            const orgId = selectedOrganization?.payload?.__auto_id__;
            if (orgId) {
                const response = await AppflyteTransactionApi.getBalanceDetails(orgId)
                if (response) {
                    const responseData = response.data ?? null;
                    setCredit(Number(responseData.credit_balance ?? 0));
                }
            }

        } catch (error) {
            console.log(error)
        } finally {
            setCreditLoading(false);
        }
    }

    useEffect(() => {

        const orgId = selectedOrganization?.payload?.__auto_id__;
        if (!orgId) return;

        const baseUrl = window.__ENV__.APPFLYTE_AUTHENTICATION_URL;
        const wsUrl = baseUrl.replace("http://", "ws://").replace("https://", "wss://");
        const ws = new WebSocket(`${wsUrl}/ws/organization/${orgId}`);

        ws.onopen = (e) => console.log("Connected")
        ws.onerror = (e) => console.log("[WS] ERROR", e);
        ws.onclose = (e) => console.log("[WS] CLOSE", e.code, e.reason);

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data.type === "credit_balance_update") {
                const organization_id = data?.organization_id ?? null;
                if (organization_id === orgId) {
                    setCredit(Number((data.credit_balance ?? 0)))
                }
            }
        };

        return () => {
            ws.close();
        };

    }, [selectedOrganization]);

    const shouldShowCreditWarning = ({ pathname }) => {
        if (!selectedOrganization || credit === null || creditLoading) return false;
        return credit <= 0.5 && pathname !== "/user/billing";
    };

    return (
        <CreditContext.Provider value={{ creditLoading, credit, shouldShowCreditWarning }}>
            {children}
        </CreditContext.Provider>
    );
};

const DEFAULTS_CONFIGS = {
    creditLoading: false,
    credit: 10,
    shouldShowCreditWarning: ({ pathname } = {}) => false,
};

export const NullCreditProvider = ({ children }) => (
    <CreditContext.Provider value={DEFAULTS_CONFIGS}>
        {children}
    </CreditContext.Provider>
);

export const useCredit = () => useContext(CreditContext);
